<div class="reporting-group-administration no-field-space">

  <sc-master-detail [selection]="[selected]" [data]="listEntries" (selectionChanged)="onSelectionChanged($event);" [newStyle]="true"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">

    @if (workingCopyDetails) {
      <div class="form" [formGroup]="detailsFormGroup">
        <div class="group-details">
          <div class="scrollable">
            @if (workingCopyDetails) {
              <div class="form-box">
                <sc-dictionary-field [model]="workingCopyDetails.name" [defaultLabel]="'name'"
                  [labelDictionaryKey]="'tmc-yard.entity.reporting-group.name'" [required]="true" [maxlength]="4000"
                  (dictionaryChanged)="onDictionaryChanged()">
                </sc-dictionary-field>
                <sc-content-spacer vertical></sc-content-spacer>
                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.sort-index"></sc-dictionary-label>
                  </mat-label>
                  <input formControlName="sortIndex" name="sortIndex" matInput matIntegerInput type="number"
                    [required]="true" />
                  </mat-form-field>
                  <sc-content-spacer vertical [double]="true"></sc-content-spacer>
                  <sc-sub-title>
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.coloring.title"></sc-dictionary-label>
                  </sc-sub-title>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <sc-flex >
                    <div>
                      <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.coloring.level-1"></sc-dictionary-label>
                    </div>
                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.color"></sc-dictionary-label>
                      </mat-label>
                      <app-color-picker formControlName="color1" (colorSelected)="colorPickerChanged()" name="color" [required]="false">
                      </app-color-picker>
                    </mat-form-field>
                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.background-color"></sc-dictionary-label>
                      </mat-label>
                      <app-color-picker formControlName="backgroundColor1" (colorSelected)="colorPickerChanged()" name="background-color"
                        [required]="false">
                      </app-color-picker>
                    </mat-form-field>
                  </sc-flex>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <sc-flex >
                    <div>
                      <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.coloring.level-2"></sc-dictionary-label>
                    </div>
                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.color"></sc-dictionary-label>
                      </mat-label>
                      <app-color-picker formControlName="color2" (colorSelected)="colorPickerChanged()" name="color" [required]="false">
                      </app-color-picker>
                    </mat-form-field>
                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.background-color"></sc-dictionary-label>
                      </mat-label>
                      <app-color-picker formControlName="backgroundColor2" (colorSelected)="colorPickerChanged()" name="background-color" [required]="false">
                      </app-color-picker>
                    </mat-form-field>
                  </sc-flex>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <sc-flex >
                    <div>
                      <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.coloring.level-3"></sc-dictionary-label>
                    </div>
                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.color"></sc-dictionary-label>
                      </mat-label>
                      <app-color-picker formControlName="color3" (colorSelected)="colorPickerChanged()" name="color" [required]="false">
                      </app-color-picker>
                    </mat-form-field>
                    <sc-content-spacer></sc-content-spacer>
                    <mat-form-field appearance="fill">
                      <mat-label>
                        <sc-dictionary-label dictionaryKey="tmc-yard.entity.reporting-group.background-color"></sc-dictionary-label>
                      </mat-label>
                      <app-color-picker formControlName="backgroundColor3" (colorSelected)="colorPickerChanged()" name="background-color" [required]="false">
                      </app-color-picker>
                    </mat-form-field>
                  </sc-flex>
                  <sc-content-spacer vertical [double]="true"></sc-content-spacer>
                  <sc-sub-title>
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.reporting-group-administration.assigned-stations.title"></sc-dictionary-label>
                  </sc-sub-title>
                  <sc-content-spacer vertical></sc-content-spacer>
                  <div class="station-assignment" style="grid-column: 1; grid-row: 6;">
                    <div class="stations-list" style="grid-column: 1; grid-row:  2;">
                      @for (station of stations; track station) {
                        <div class="station">
                          {{station.name}}
                          <i (click)="removeStation(station)" class="cursor-pointer fa-light fa-times"></i>
                        </div>
                      }
                    </div>
                    <div class="delete-button-wrapper" style="grid-column: 2; grid-row:  2;">
                      <i class="cursor-pointer fa-light fa-plus" (click)="addStation()"></i>
                    </div>
                  </div>
                  <sc-content-spacer vertical [double]="true"></sc-content-spacer>
                  <sc-sub-title>
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.reporting-group-administration.assigned-station-sets.title"></sc-dictionary-label>
                  </sc-sub-title>
                  <div class="station-assignment" style="grid-column: 1; grid-row: 8;">
                    <div class="stations-list" style="grid-column: 1; grid-row:  2;">
                      @for (stationSet of stationSets; track stationSet) {
                        <div class="station">
                          {{stationSet.name}}
                          <i (click)="removeStationSet(stationSet)" class="cursor-pointer fa-light fa-times"></i>
                        </div>
                      }
                    </div>
                    <div class="delete-button-wrapper" style="grid-column: 2; grid-row:  2;">
                      <i class="cursor-pointer fa-light fa-plus" (click)="addStationSet()"></i>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <ng-template masterDetailToolbar>
        <sc-cancel-button type="button" class="config-changed-button" (click)="cancel()"
        [disabled]="!cancelEnabled"></sc-cancel-button>
        <sc-content-spacer></sc-content-spacer>
        <sc-save-button primary type="button" class="config-changed-button" (click)="save()"
        [disabled]="!saveEnabled"></sc-save-button>
      </ng-template>

    </sc-master-detail>
  </div>
